import React, { useEffect, useState, useRef } from 'react';
import { savePreferences } from './Preferences.js';
import './AnalysisPanel.css'

const AnalysisPanel = ({ 
  showMarkers, setShowMarkers, 
  isBackgroundRemoved, setIsBackgroundRemoved,
  showCoordinates, setShowCoordinates,
  showBlackAnalysis, setShowBlackAnalysis, 
  showWhiteAnalysis, setShowWhiteAnalysis, 
  preferences, setPreferences 
  }) => {

    const {
      'blunder': blunderThreshold, 
      'mistake': mistakeThreshold, 
      'inaccuracy': inaccuracyThreshold, 
      'good': goodThreshold, 
      'great': greatThreshold, } = preferences.evaluationThresholds
  
  // Toggle showing evaluation markers on current moves
    const toggleShowMarkers = () => {
      setShowMarkers(!showMarkers)

      // update preferences
      updatePreferences({
        ...preferences, 
        showMarkers: !showMarkers,
      });
  }

  // Toggle the board's background visibility on checkbox change
  const toggleShowBackground = () => {
    setIsBackgroundRemoved(!isBackgroundRemoved);
    // update preferences
    updatePreferences({
      ...preferences, 
      isBackgroundRemoved: !isBackgroundRemoved,
    });
  };

  // Toggle showing the coordinates on checkbox change
  const toggleShowCoordinates = () => {
    setShowCoordinates(!showCoordinates);
    // update preferences
    updatePreferences({
      ...preferences, 
      showCoordinates: !showCoordinates,
    });
  };

  // Toggle showing black analysis on checkbox change
  const toggleShowBlackAnalysis = () => {
    setShowBlackAnalysis(!showBlackAnalysis);
  };

  // Toggle showing white analysis on checkbox change
  const toggleShowWhiteAnalysis = () => {
    setShowWhiteAnalysis(!showWhiteAnalysis);
  };

  // Listener for collapsing preference panel. 
  const handlePreferenceCollapseButtonClick = () => {
    const collapseButton = document.getElementById("preference-collapse-button");
    const collapsibleContent = document.getElementById("preference-panel-inner");
    const isHidden = collapsibleContent.classList.toggle("hidden");
  }

  const handleUpdateThresholdsButton = async (event) => {
    event.preventDefault(); // Prevent form from reloading the page

    const thresholdLabels = Object.keys(preferences.evaluationThresholds) // ['blunder','mistake','inaccuracy','good','great']

    let newEvaluationThresholds = preferences.evaluationThresholds

    for (const label of thresholdLabels) {
      const htmlFormElementId = label + 'Threshold';
      const newThreshold = document.getElementById(htmlFormElementId).value;

      if(newThreshold && !isNaN(newThreshold)) { // update threshold if new value is permissible

        newEvaluationThresholds = {
          ...newEvaluationThresholds, 
          [label]: newThreshold, 
        }
      } else {
        if(isNaN(newThreshold))
          console.warn("Did not update",label,"threshold because",newThreshold,"is not a number.")
      }
    } // end of for loop 


    // update preferences
    updatePreferences({
      ...preferences, 
      evaluationThresholds: newEvaluationThresholds
    });
  }

  const updatePreferences = async (updatedPreferences) => {
    setPreferences(updatedPreferences) 
    // update server copy of preferences 
    try {
      const serverPreferences = await savePreferences(updatedPreferences);
      console.log("Preferences updated:", serverPreferences);
    } catch (error) {
      console.error("Failed to update preferences:", error);
    }
  }

    return (
    <div id="preference-panel" className="panel">
      <span
        id="preference-collapse-button" 
        onClick={() => handlePreferenceCollapseButtonClick()} >
        Analysis
      </span>
    <div id="preference-panel-inner">
    {/* Toggle preferences */}
    <div className="panel-item">
      <label class="switch">
        <input type="checkbox"
          id="ShowBlackAnalysisCheckbox"
          checked={showBlackAnalysis}
          onChange={toggleShowBlackAnalysis}
        />
        <span class="slider"></span>
      </label>
      <div className="panel-description"><p>Black analysis</p></div>
    </div>
    <div className="panel-item">
      <label class="switch">
        <input type="checkbox"
          id="ShowWhiteAnalysisCheckbox"
          checked={showWhiteAnalysis}
          onChange={toggleShowWhiteAnalysis}
        />
        <span class="slider"></span>
      </label>
      <div className="panel-description"><p>White analysis</p></div>
    </div>
    <div className="panel-item">
      <label class="switch">
        <input type="checkbox"
          id="ShowMarkersSwitch"
          checked={showMarkers}
          onChange={toggleShowMarkers}
        />
        <span class="slider"></span>
      </label>
      <div className="panel-description"><p>Show markers</p></div>
    </div>
    <div className="panel-item">
      <label class="switch">
        <input type="checkbox"
          id="ShowCoordinatesCheckbox"
          checked={showCoordinates}
          onChange={toggleShowCoordinates}
        />
        <span class="slider"></span>
      </label>
      <div className="panel-description"><p>Coordinates</p></div>
    </div>
    <div className="panel-item">
      <label class="switch">
        <input type="checkbox"
          id="ClearBackgroundCheckbox"
          checked={isBackgroundRemoved}
          onChange={toggleShowBackground}
        />
        <span class="slider"></span>
      </label>
      <div className="panel-description"><p>Clear board</p></div>
    </div>
    {/* Set evaluation thresholds  */}
    <div className="threshold-panel">
      <div className="left-aligned">
        <div className="threshold">
          <p>Blunder:</p>
          <input type="number" id="blunderThreshold" defaultValue={blunderThreshold} step="0.5" onChange={handleUpdateThresholdsButton} />
        </div>
        <div className="threshold">
          <p>Mistake:</p>
          <input type="number" id="mistakeThreshold" defaultValue={mistakeThreshold} step="0.5" onChange={handleUpdateThresholdsButton} />
        </div>
        <div className="threshold">
          <p>Inaccuracy:</p>
          <input type="number" id="inaccuracyThreshold" defaultValue={inaccuracyThreshold} step="0.5" onChange={handleUpdateThresholdsButton} />
        </div>
        <div className="threshold">
          <p>Good:</p>
          <input type="number" id="goodThreshold" defaultValue={goodThreshold} step="0.5" onChange={handleUpdateThresholdsButton} />
        </div>
        <div className="threshold">
          <p>Great:</p>
          <input type="number" id="greatThreshold" defaultValue={greatThreshold} step="0.5" onChange={handleUpdateThresholdsButton} />
        </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default AnalysisPanel;